import { render } from "./Payment-Method.vue?vue&type=template&id=409c9853"
import script from "./Payment-Method.vue?vue&type=script&lang=js"
export * from "./Payment-Method.vue?vue&type=script&lang=js"

import "./Payment-Method.vue?vue&type=style&index=0&id=409c9853&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__